import { TblViewSpec } from '../../../core/table/table-view.types';
import { TblCol } from '../../../core/table/table.types';
import { tblSpecAddColumn } from '../../../core/table/spec';
import BooleanToStringRenderer from '../../../core/table/renderers/BooleanToStringRenderer';
import ReconcileLinkRenderer from './ReconcileLinkRenderer';

export type ColKey =
    | ''
    | 'LineNum'
    | 'VendorItemNum'
    | 'NDC'
    | 'VendorItemName'
    | 'DrugInfo'
    | 'Overallocated'
    | 'PackagesShipped'
    | 'PricePerPackage'
    | 'Amount'
    | 'Reconcile'
    | 'IsRebate';

export function CpOrderInvoiceLineItemsColumnSpec(): Map<string, TblCol> {
    const map = new Map<ColKey, TblCol>();
    tblSpecAddColumn<ColKey>(map, 'LineNum', { title: 'Line #', type: 'NUMBER' });
    tblSpecAddColumn<ColKey>(map, 'VendorItemNum', { title: 'Item Number', type: 'TEXT' });
    tblSpecAddColumn<ColKey>(map, 'NDC', { title: 'NDC', type: 'TEXT' });
    tblSpecAddColumn<ColKey>(map, 'VendorItemName', { title: 'Vendor Item Name', type: 'TEXT' });
    tblSpecAddColumn<ColKey>(map, 'DrugInfo', { title: 'Drug Info', type: 'TEXT' });
    tblSpecAddColumn<ColKey>(
        map,
        'Overallocated',
        { title: 'Over Allocated', type: 'BOOLEAN' },
        BooleanToStringRenderer,
    );
    tblSpecAddColumn<ColKey>(map, 'PackagesShipped', { title: 'Packages Shipped', type: 'NUMBER' });
    tblSpecAddColumn<ColKey>(map, 'PricePerPackage', { title: 'Per Package', type: 'NUMBER' });
    tblSpecAddColumn<ColKey>(map, 'Amount', { title: 'Total Price', type: 'NUMBER' });
    tblSpecAddColumn<ColKey>(
        map,
        'Reconcile',
        { title: 'Reconcile', type: 'TEXT', hasFilter: false, hasSort: false },
        ReconcileLinkRenderer,
    );
    tblSpecAddColumn<ColKey>(map, 'IsRebate', { title: 'Rebate', type: 'BOOLEAN' }, BooleanToStringRenderer);
    return map;
}

// source of truth for all possible columns/sections for CP Order Invoice Line Items
export function cpOrderInvoiceLineItemsAllColumnsView(): TblViewSpec {
    return {
        key: 'all',
        title: 'All Columns',
        sections: [
            { title: 'Vendor Invoice', cols: ['LineNum', 'VendorItemNum'] },
            { title: 'Drug Info', cols: ['NDC', 'VendorItemName', 'Overallocated'] },
            { title: 'Qty', cols: ['PackagesShipped'] },
            { title: 'Invoice Pricing', cols: ['PricePerPackage', 'Amount'] },
        ],
        sortby: 'LineNum',
    };
}

export function cpOrderInvoiceLineItemsWithOptionalColumnsView(
    reconcile: boolean,
    rebate: boolean,
    showOverallocated: boolean = true,
): TblViewSpec {
    const drugInfoCols = ['NDC', 'VendorItemName'];
    if (showOverallocated) drugInfoCols.push('Overallocated');

    const cols: string[] = [];
    if (reconcile) {
        cols.push('Reconcile');
    }
    if (rebate) {
        cols.push('IsRebate');
    }
    return {
        key: 'optional-cols',
        title: 'All Columns',
        sections: [
            { title: 'Vendor Invoice', cols: ['LineNum', 'VendorItemNum'] },
            { title: 'Drug Info', cols: drugInfoCols },
            { title: 'Qty', cols: ['PackagesShipped'] },
            { title: 'Invoice Pricing', cols: ['PricePerPackage', 'Amount'] },
            { title: 'Details', cols },
        ],
        sortby: 'LineNum',
    };
}
